import React from 'react';
import { Box } from '@chakra-ui/react';

import { DepositAmountInfo } from '../DepositAmountInfo/DepositAmountInfo';
import { ExpiryDaysInfo } from '../ExpiryDaysInfo/ExpiryDaysInfo';
import { ItemCountsInfo } from '../ItemCountsInfo/ItemCountsInfo';
import { ItemsTable } from '../ItemsTable/ItemsTable';

export const DepositSuccessResult = () => {
  return (
    <Box px={8} pt={4}>
      <DepositAmountInfo />
      <ExpiryDaysInfo />
      <ItemCountsInfo />
      <ItemsTable />
    </Box>
  );
};
